import moment from "moment";
import CryptoJS from "crypto-js";
// CryptoJS.MD5(password + CryptoJS.MD5(password)).toString()

//判断设备系统名称
export function isAndroid() {
  var u = navigator.userAgent;
  return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
}

export function isIos() {
  var u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
}

export function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
  } else {
      return false;
  }
}

// 获取n~m区间的随机数
export const rd = (n, m) => {
  let c = m - n + 1;
  return Math.floor(Math.random() * c + n);
};

// 格式化日期
export const formatData = (date, type = "YYYY-MM-DD HH:mm") => moment(date).format(type);

export const sort_ASCII = (obj) => {
  let arr = new Array();
  let num = 0;
  const secret = "TKGKItgT"
  for (let i in obj) {
    arr[num] = i;
    num++;
  }
  let sortArr = arr.sort();
  sortArr = sortArr.map(item => {
    if (obj[item]) {
      return `${item}=${encodeURIComponent(obj[item])}`
    } else {
      return ''
    }
  })
  sortArr = sortArr.filter(item => !!item);
  let sortString = `${sortArr.join("&")}${secret}`;
  return CryptoJS.MD5(sortString).toString().toLowerCase()
}

//引入客服标签
export const insertScript = url => {
	const s = document.createElement('script');
	s.type = 'text/javascript';
	s.async ='async';
  s.defer = 'defer';
	s.src = url;
	return s
}

// 拼接query字符串
const composeQuery = query => {
  if (!query) return "";
  try {
    let arr = [];
    for (let item in query) {
      arr.push(`${item}=${query[item]}`);
    }
    return arr.join("&")  
  } catch (error) {
    return "";
  }
}

// 避免ios复制链接问题，wx内路由跳转使用原生跳转
export const pushLink = (path, query) => {
  const _url = `${window.location.protocol}//${window.location.hostname}${path}?${composeQuery(query)}`
  window.location.assign(_url)
}
export const replaceLink = (path, query) => {
  const _url = `${window.location.protocol}//${window.location.hostname}${path}?${composeQuery(query)}`
  window.location.replace(_url)
}

/**
 * 判断当前域名是否为悦玩域名
 * 悦玩域名: yuwanc.com, w2you.com, bgyxy.com
 */
export const isYuwanDomain = () => {
  const host = location.host;
  return host.includes('yuwanc.com') || host.includes('w2you.com') || host.includes('bgyxy.com');
}

/**
 * 根据域名获取正确的 appkey
 * 悦玩域名使用 ywAppkey，其他使用 appkey
 * @param {Object} route - 路由对象，需要包含 meta.appkey 和 meta.ywAppkey
 */
export const getCurrentAppkey = (route) => {
  return isYuwanDomain() ? route.meta.ywAppkey : route.meta.appkey;
}